export default function LicencesApi({ makeRequest, buildRequest }) {

    function getLicencesByCentre(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Licences/ByCentre/${centreId}`));
        });
    }

    function upsertLicence(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Licences/Upsert', payload));
        });
    }

    function deleteLicence(licenceId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Licences/${licenceId}`));
        });
    }

    // Licence Hours
    function getLicenceHours(licenceId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Licences/Hours/${licenceId}`));
        });
    }

    function upsertLicenceHours(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Licences/Hours/Upsert', payload));
        });
    }

    function deleteLicenceHours(licenceHoursId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Licences/Hours/${licenceHoursId}`));
        });
    }

    // Licence Statuses
    function getLicenceStatuses() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Licences/LicenceStatuses'));
        });
    }

    function upsertLicenceStatus(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Licences/LicenceStatuses/Upsert', payload));
        });
    }

    function deleteLicenceStatus(licenceStatusId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Licences/LicenceStatuses/${licenceStatusId}`));
        });
    }

    //license Classes
    function getLicenceClasses() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Licences/LicenceClasses'));
        });
    }

    function upsertLicenceClass(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Licences/LicenceClasses/Upsert', payload));
        });
    }

    function deleteLicenceClass(licenceClassId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Licences/LicenceClasses/${licenceClassId}`));
        });
    }
    
    //license Services
    function getLicenceServices() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Licences/LicenceServices'));
        });
    }
    function upsertLicenceService(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Licences/LicenceServices/Upsert', payload));
        });
    }
    function deleteLicenceService(licenceServiceId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Licences/LicenceServices/${licenceServiceId}`));
        });
    }

    return {
        getLicencesByCentre,
        upsertLicence,
        deleteLicence,
        getLicenceHours,
        upsertLicenceHours,
        deleteLicenceHours,
        getLicenceStatuses,
        upsertLicenceStatus,
        deleteLicenceStatus,
        getLicenceClasses,
        upsertLicenceClass,
        deleteLicenceClass,
        getLicenceServices,
        upsertLicenceService,
        deleteLicenceService,
    };
}
